import { atom } from 'recoil';

import { IS_FULL_SCREEN } from '../constants';

export const AIsFullScreen = atom<boolean>({
  key: IS_FULL_SCREEN,
  default: false,
});
